import styled from 'styled-components'
import { Theme } from '../../Theme';

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    -ms-overflow-style: none;
    scrollbar-width: none;

    .BannerArea {
        width: 100%;
        height: 630px;
        overflow: hidden;
        border-bottom-left-radius: 40px;
        border-bottom-right-radius: 40px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }

    .DivisorTittle2 {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 40px;

        h1 {
            color: ${Theme.FIRST_COLOR};
            font-family: ${Theme.FIRST_FONT};
            font-size: 28px;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 10px;
            text-align: center;
        }

        .Underline {
            width: 80px;
            height: 4px;
            background-color: ${Theme.SECOND_COLOR};
            border-radius: 2px;
        }
    }

    .TrainingAreasArea {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 80px;
        padding-bottom: 80px;
        background-color: #fafafa;
    }

    .MiniCardArea {
        width: 95%;
        max-width: 1400px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 25px;
        flex-wrap: wrap;
    }

    .TestymonyArea {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 120px;
        background-color: white;
        overflow: hidden;

        .TestymonyHeader {
            text-align: center;
            margin-bottom: 60px;

            h2 {
                font-family: ${Theme.FIRST_FONT};
                font-size: 28px;
                font-weight: 900;
                color: ${Theme.FIRST_COLOR};
                text-transform: uppercase;
                margin-bottom: 10px;
            }

            p {
                font-family: ${Theme.FIRST_FONT};
                font-size: 16px;
                color: #666;
                max-width: 500px;
            }
        }

        .TestymonyWrapper {
            width: 95%;
            max-width: 1500px;
            overflow: hidden;
            position: relative;
        }

        .TestymonyContainer {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            width: 100%;
            gap: 1%;

            & > * {
                flex: 0 0 49%;
                flex-shrink: 0;
            }
        }
    }

    .BlogHighlightsArea {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px;
        gap: 35px;
    }

    .DivisorTittle{
        margin-top: 20px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 1366px) {
        .BannerArea {
            height: 490px;
        }
    }

    @media (max-width: 768px) {
        .BannerArea {
            height: 420px;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }

        .DivisorTittle2 {
            width: 90%;
            h1 { font-size: 24px; }
            p { font-size: 14px; padding: 0 10px; }
        }

        .TrainingAreasArea {
            padding: 40px 0;
        }

        .MiniCardArea {
            gap: 5%;
            
            & > * {
                flex: 0 0 40%;
                max-width: 40%;
                min-width: 40%;
            }
        }

        .TestymonyArea {
            padding: 50px 0;
            
            .TestymonyHeader {
                margin-bottom: 30px;
                h2 { font-size: 22px; }
            }

            .TestymonyWrapper {
                width: 90%;
            }

            .TestymonyContainer {
                width: 100%;
                justify-content: flex-start;
                gap: 0;

                & > * {
                    flex: 0 0 100%;
                    flex-shrink: 0;
                }
            }
        }
    }
`;

export const Styled = {
    Content
}
